<template>
    <div
        v-loading="loading"
        element-loading-background="rgba(0, 0, 0, 0.08)"
        class="loading">
    </div>
</template>
<script>
export default {
    name: 'Start',
    data()
    {
        return {
            loading: true
        }
    },
    beforeMount()
    {
        document.title = this.$root.$data.system.title;
        return Fx.Promise.then(()=>
        {
           // return Fx.Http.post("/system/constant/export").
           // then((resp)=>
           // {
           //     if(resp.isSuccess())
           //     {
           //         top.Constant = resp.getData();
           //         Fx.$globalVue.__proto__.$topConstant = top.Constant;
           //     }
           // });
        }).
        then(()=>
        {
            return Fx.Http.post('/system/user/touchSession').
            then((response)=>
            {
                console.log(response)
                if(response.isSuccess()&&response.getData('isLogin'))
                {
                    setTimeout(()=>{
                        this.loading = false;
                        this.$store.commit('session/setSessionUser', {
                            userId: response.getData("userId"),
                            username: response.getData("username"),
                            nickname: response.getData("nickname")
                        });
                        let redirect = this.$route.query.redirect;
                        if(redirect)
                        {
                            this.$router.replace(redirect);
                        }
                        else
                        {
                            this.$router.replace('/');
                        }
                    }, 618);
                }
                else
                {
                    setTimeout(()=>{
                        this.$router.replace({
                            path: '/login',
                            query: this.$route.query
                        });
                        this.loading = false;
                    }, 618);
                }
            });
        });
    }
}
</script>
<style>
    .loading
    {
        width: 100%;
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/modules/common/pages/Start.vue